import React from 'react';
import styles from './quota-header.scss';
import { defineMessages, useIntl } from 'react-intl';
import HfReactHelper from '../../../../common/utils/hf-react-helper';

/*
  todo: DEV-10013: Convert QuotaHeader to use
    hellosign-web/src/hellospa/page/prep-and-send/data/actions/bannerMessage.ts
 */

type Props = {
  numDocsLeft: number,
}

const messages = defineMessages({
  usageThree: {
    id: '',
    description: 'Text displaying current usage for the user.',
    defaultMessage: 'You can send {numDocsLeft} documents this month for free.',
  },
  usageOthers: {
    id: '',
    description: 'Text displaying current usage for the user.',
    defaultMessage: '{numDocsLeft, plural, =1{ You can send # more document this month for free.} '
      + 'other { You can send # more documents this month for free.}}',
  },
  overQuota: {
    id: '',
    description: 'Text notifying user that they have used up all of their free signatures for the month',
    defaultMessage: 'You can send no more document this month for free.',
  },
  upgrade: {
    id: '',
    description: 'Text for the upgrade link',
    defaultMessage: 'Upgrade for unlimited documents',
  },
});

const upgradeUrl = HfReactHelper.urlHelper('dropbox/bridge?pricing=1', 'hellosign');

const QuotaHeader = ({ numDocsLeft } : Props) => {
  const intl = useIntl();
  const bannerClass = numDocsLeft > 0 ? styles.info : styles.warning;
  const message = numDocsLeft > 0
    ? intl.formatMessage(
      (numDocsLeft === 3
        ? messages.usageThree
        : messages.usageOthers
      ),
      { numDocsLeft },
    )
    : intl.formatMessage(messages.overQuota);

  const cta = <a href={upgradeUrl} target="_new">{intl.formatMessage(messages.upgrade)}</a>;

  return (
    <div
      className={bannerClass}
      role="alert"
      data-qa-ref="quota-banner"
      data-qa-over-quota={numDocsLeft <= 0}
    >
      {message} {cta}
    </div>
  );
};

export default QuotaHeader;
